(() => {
  if (window.__hapiveriPilotTrackingBound) return;
  window.__hapiveriPilotTrackingBound = true;
  const articleHandles = {
    '568996233382': 'characteristics-and-appeal-of-kurume-kasuri-the-beauty-of-indigo-dye-for-everyday-life',
    '567399973030': 'blending-tradition-and-functionality-introducing-kurume-kasuri-yoga-wear'
  };
  const productHandles = {
    '7257574703270': 'kurumekasuriworkwear',
    '7535990014118': 'kurume-kasuri-yoga-wear-charcoal'
  };
  const debug = String(window.Shopify?.theme?.id) === '198644662438' &&
    new URLSearchParams(location.search).get('hapiveri_pilot_debug') === '1';
  const diagnostic = (message, data) => {
    if (debug) console.info('HAPIVERI pilot GA4: ' + message + ' ' + JSON.stringify(data));
  };
  if (debug && typeof PerformanceObserver === 'function') {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        const request = new URL(entry.name, location.origin);
        if (!request.pathname.endsWith('/g/collect') ||
          request.searchParams.get('en') !== 'hapiveri_article_product_click') continue;
        diagnostic('network resource observed', {
          endpoint: request.origin + request.pathname,
          measurement_id: request.searchParams.get('tid'),
          event_name: request.searchParams.get('en'),
          source_article_handle: request.searchParams.get('ep.source_article_handle'),
          target_product_handle: request.searchParams.get('ep.target_product_handle'),
          link_placement: request.searchParams.get('ep.link_placement'),
          initiator_type: entry.initiatorType
        });
      }
    });
    observer.observe({ type: 'resource', buffered: true });
  }
  const consentAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const ready = () => diagnostic('readiness', {
    gtagAvailable: typeof window.gtag === 'function',
    consentApiAvailable: typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function',
    analyticsAllowed: consentAllowed()
  });
  if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') ready();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
  } else ready();

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-hapiveri-pilot] a[data-pilot-product-id]');
    if (!link) return;
    const block = link.closest('[data-hapiveri-pilot]');
    const articleId = block.dataset.pilotArticleId;
    const productId = link.dataset.pilotProductId;
    if (!articleHandles[articleId] || !productHandles[productId] ||
      (articleId === '567399973030' && productId !== '7535990014118')) return;
    const target = new URL(link.href, location.origin);
    if (target.origin !== location.origin || target.pathname !== '/products/' + productHandles[productId]) return;
    document.dispatchEvent(new CustomEvent('hapiveri:pilot-product-click', {
      detail: { article_id: articleId, product_id: productId, placement: link.dataset.pilotPlacement }
    }));
    if (!consentAllowed() || typeof window.gtag !== 'function') {
      diagnostic('not sent: consent or existing gtag unavailable', { analyticsAllowed: consentAllowed(), gtagAvailable: typeof window.gtag === 'function' });
      return;
    }
    const parameters = {
      send_to: 'G-DWQZ8ESNT3',
      source_article_handle: articleHandles[articleId],
      target_product_handle: productHandles[productId],
      link_placement: link.dataset.pilotPlacement
    };
    if (debug) parameters.debug_mode = true;
    window.gtag('event', 'hapiveri_article_product_click', parameters);
    diagnostic('submitted to existing gtag (receipt unverified)', parameters);
  });
})();
